/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import _ from "lodash";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import {
  // Button,
  Page,
  Container,
  Stack,
  // Typography,
  // TextField,
  // TextareaAutosize,
  // Accordion,
  // AccordionSummary,
  // AccordionDetails,
  // Box,
  // FormControl,
  // Select,
  // MenuItem,
} from "@common-ui/ui";
// import { ExpandMore } from "@mui/icons-material";
// import DownloadIcon from "@mui/icons-material/Download";
// import isEqual from "date-fns/isEqual";
// import isAfter from "date-fns/isAfter";
// import isBefore from "date-fns/isBefore";
import {
  Header,
  // ScopingHeader,
  TransferList,
} from "../../components";
import { WorkItemTableView } from "./WorkItemTableView";
import {
  getOrgWorkEvent,
  updateWorkEvent,
  // getOrg,
  getWorkItems,
  createWorkItems,
  getCustomerAssets,
  removeWorkItems,
  // getProcedure,
  updateWorkItem,
} from "../../services";
// import { getOrgCustomer } from "../../services/orgCustomer";
import { updateWorkEventStatus } from "../../services/workEvent";
import { getProcedureStatus } from "../../services/procedureRuntime";
import { workItemsSlice } from "../../reducers/workItemsReducer";
import { workEventSlice } from "../../reducers/workEventReducer";
import { WorkEventHeader } from "./WorkEventHeader";

export const EditWorkEvent = () => {
  let { handleModal } = React.useContext(ModalContext);
  let params = useParams();
  let history = useHistory();
  const dispatch = useDispatch();
  const serverWorkItems = Object.entries(
    useSelector((state) => state.workItems)
  ).map(([key, value]) => value);
  const workEventData = useSelector((state) => state.workEvent[params?.id]);
  const workItemsData = useSelector((state) => state.workItems);
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let appRole = currentOrganization?.app_role;

  const [, setForCustomer] = useState("");
  const [, setIsLoading] = useState(false);
  const [workEvent, setWorkEvent] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [places, setPlaces] = useState([]);
  const [workItems, setWorkItems] = useState([]);
  const [assets, setAssets] = useState([]);
  const [allAsset, setAllAsset] = useState([]);
  const [newPlaceParent, setNewPlaceParent] = useState(undefined);
  const [totalWorkItemCompleted, setTotalWorkItemCompleted] = useState(0);
  const [technicians, setTechnicians] = useState([]);
  const [breadcrumbs] = useState([
    { label: "All Work Events", link: "/work-events" },
  ]);

  const setServerWorkItems = async (incomingWorkItems = []) => {
    async function init(work) {
      try {
        // let procedure = await getProcedure(
        //   work?.service_option_procedure,
        //   work?.performing_org,
        //   work?.service_type,
        //   work?.service_option
        // );
        let procedure = work?.service?.procedure;
        let procedureStatus = {};
        try {
          procedureStatus = await getProcedureStatus(
            work?.performing_org,
            params?.id,
            work.id
          );
          // console.log("procedureStatus", procedureStatus);
        } catch (error) {}
        dispatch(
          workItemsSlice.actions.setWorkItem({
            ...work,
            defaultProcedure: procedure,
            procedure: { ...procedure, status: procedureStatus },
          })
        );
      } catch (error) {
        console.log(error);
      }
    }
    incomingWorkItems.forEach((work) => {
      init(work);
    });
  };

  const initTransferList = async (
    newCustomer,
    newPlaceParent,
    newWorkEvent
  ) => {
    if (newCustomer && newWorkEvent) {
      let newAssets = await getCustomerAssets(
        params?.orgId,
        newCustomer.system_id ? newCustomer.system_id : newCustomer.id
      );
      // console.log("newAssets", newAssets);
      if (newPlaceParent) {
        newAssets = newAssets.filter((newAsset) => {
          if (newAsset["place"] && newAsset["place"]["system_id"]) {
            if (newPlaceParent.system_id) {
              return (
                newAsset["place"]["system_id"] === newPlaceParent?.system_id
              );
            } else {
              return newAsset["place"]["system_id"] === newPlaceParent?.id;
            }
          }
          return false;
        });
      }
      setAllAsset(newAssets);
      const newServerWorkItems = await getWorkItems(
        newWorkEvent?.id,
        params?.orgId
      );
      console.log("newServerWorkItems", newServerWorkItems);

      const indexLookUp = _.keyBy(newServerWorkItems, (object) => {
        return object.asset?.system_id;
      });
      const filterNewAssets = _.filter(newAssets, (asset) => {
        return indexLookUp[asset.system_id] === undefined;
      });
      setAssets(filterNewAssets);
      let filterWorkItems = _.map(newAssets, (asset) => {
        if (indexLookUp[asset.system_id] !== undefined) {
          return {
            ...asset,
            workItemID: indexLookUp[asset.system_id]["id"],
          };
        } else {
          return asset;
        }
      });
      filterWorkItems = _.filter(filterWorkItems, (asset) => {
        return indexLookUp[asset.system_id] !== undefined;
      });

      const assetIndexLookUp = _.keyBy(filterWorkItems, (asset) => {
        return asset.system_id;
      });
      let workItemWithAssets = _.map(newServerWorkItems, (work) => {
        return {
          ...work,
          assetDetails: assetIndexLookUp[work.asset],
        };
      });
      setServerWorkItems(workItemWithAssets);

      setWorkItems(filterWorkItems);
    }
  };

  const getWorkEvent = async () => {
    setIsLoading(true);
    try {
      const response = await getOrgWorkEvent(params?.orgId, params?.id);
      // console.log("response", response);

      // Fix for customers and places
      // const customerId = response?.data?.for_customer;
      const places = String(response?.data?.for_place)
        ?.split(`"`)
        ?.filter((item) => item !== "}")
        ?.filter((item) => item !== "{")
        ?.filter((item) => item !== ",");

      setPlaces(places);
      setCustomer(response?.data?.for_customer || response?.data?.for_org);
      setWorkEvent(response?.data);
      setForCustomer(response?.data?.for_customer);
      setIsLoading(false);
    } catch (error) {
      alert(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // console.log("customer,", customer);
    initTransferList(customer, newPlaceParent, workEvent);
  }, [
    JSON.stringify(customer),
    newPlaceParent,
    JSON.stringify(workEvent),
    JSON.stringify(workEventData),
  ]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      work_order_reference: "",
      purchase_order_reference: "",
      scheduled_start_date: "",
      scheduled_end_date: "",
      notes: "",
    },
    validationSchema: Yup.object({
      work_order_reference: Yup.string().nullable().trim(),
      purchase_order_reference: Yup.string().nullable().trim(),
      scheduled_start_date: Yup.date().nullable(),
      scheduled_end_date: Yup.date().nullable(),
      notes: Yup.string().nullable().trim(),
    }),
    onSubmit: async () => {
      if (!customer) {
        // return alert("Please select Owner or Customer!");
        return handleModal("Please Select Owner Or Client", "Alert");
      }
      setIsLoading(true);
      try {
        await updateWorkEvent(params?.orgId, params?.id, {
          ...formik.values,
          for_org: customer?.id ? customer?.id : null,
          for_customer: customer?.system_id ? customer?.system_id : null,
          for_place: places ? places : [],
        });
        getWorkEvent();
      } catch (error) {
        alert(error);
        history.go(0);
      }
    },
  });

  useEffect(() => {
    dispatch(workEventSlice.actions.reset());
    getWorkEvent();
    return () => {
      dispatch(workItemsSlice.actions.reset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (workEvent && Object.keys(workEvent).length > 0) {
      dispatch(workEventSlice.actions.setWorkEvent(workEvent));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workEvent]);

  useEffect(() => {
    const completedWorkItems = _.filter(workItemsData, {
      status: "COMPLETED",
    });
    if (Object.values(workItemsData).length === completedWorkItems.length) {
      setTotalWorkItemCompleted(completedWorkItems.length);
    }
    const filterTechniciansData = _.filter(workItemsData, (item) => {
      return item.performing_user !== null;
    });
    if (filterTechniciansData.length) {
      setTechnicians(_.map(filterTechniciansData, "performing_user"));
    }
  }, [workItemsData]);

  // Handle change of work item status.
  const handleWorkItemStatusChange = async (
    event,
    workEventId,
    workItemId,
    newStatus = undefined,
    procedure_done = undefined
  ) => {
    const attributes = {
      status: newStatus ? newStatus : event.target.value,
    };
    try {
      await updateWorkItem(attributes, workEventId, workItemId, params?.orgId);
      dispatch(
        workItemsSlice.actions.setWorkItemStatus({
          workItemId: workItemId,
          status: event.target.value,
          procedure_done,
        })
      );
    } catch (e) {}
  };

  // Handles the work event status update.
  const handleWorkEventStatusChange = async (event, workEventId) => {
    const attributes = {
      status: event.target.value,
    };
    try {
      await updateWorkEventStatus(params?.orgId, workEventId, attributes);
      dispatch(
        workEventSlice.actions.setWorkEventStatus({
          id: workEventId,
          status: event.target.value,
        })
      );
    } catch (e) {}
  };

  return (
    <Page title="FlukeWorks" sx={{ background: "#F5F5F5" }}>
      <Header
        xl
        name="Work Event"
        history={history}
        breadcrumbs={[
          ...breadcrumbs,
          { label: `Work Event: ${params?.id}`, link: null },
        ]}
      />
      {/* <ProfileBreadcrumbs>
        <Link color="inherit" href="/work-events" underline="hover">
          All Work Events
        </Link>
        <Typography
          style={{ fontWeight: "bold" }}
        >{`Work Event: ${params?.id}`}</Typography>
      </ProfileBreadcrumbs> */}
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        {workEventData?.id ? (
          <Stack>
            <WorkEventHeader
              getWorkEvents={getWorkEvent}
              places={places}
              workEvent={workEventData}
              customer={customer}
              orgId={params?.orgId}
              workItems={serverWorkItems}
              totalWorkItemCompleted={totalWorkItemCompleted}
              workEventStatusChange={handleWorkEventStatusChange}
              technicians={technicians}
              setNewPlaceParent={setNewPlaceParent}
              appRole={appRole}
            />
          </Stack>
        ) : (
          ""
        )}

        <Stack>
          {/* Transfer List */}
          <WorkItemTableView
            data={serverWorkItems}
            orgID={params?.orgId}
            workEvent={workEvent}
            appRole={appRole}
            workItemStatusChange={handleWorkItemStatusChange}
            Add={
              <TransferList
                workEvent={workEvent}
                workItems={workItems}
                setWorkItems={setWorkItems}
                assets={assets}
                setAssets={setAssets}
                createWorkItems={createWorkItems}
                serverWorkItems={serverWorkItems}
                setServerWorkItems={setServerWorkItems}
                getWorkItems={getWorkItems}
                orgID={params?.orgId}
                removeWorkItems={removeWorkItems}
                allAsset={allAsset}
                customer={customer}
                places={places}
                newPlaceParent={newPlaceParent}
                initTransferList={initTransferList}
                appRole={appRole}
              />
            }
          />
        </Stack>
      </Container>
    </Page>
  );
};
